<template>
  <div class="footer">
    <div class="section last">
      <div class="container last w-container">
        <div class="footer-block">
          <a @click="goHome" id="w-node-bd35c41e-61b3-501a-b5b5-76a67d389e27-e94b0a3f" class="navbar-logo-link w-nav-brand"><img src="../../../../../public/images/Logo-Vse.-Zaimi.svg" loading="lazy" alt="" class="navbar-logo"></a>
          <div class="text-classic white mini">© 2026, Всем займы</div>
        </div>
        <div class="grid-colum top">
          <p class="plane-text">
            Услугу подбора предложений предоставляет ИП Харина Василиса Павловна, ОГРН 322595800010220, ИНН 594702874304.<br><br>
            Сайт оказывает бесплатные услуги по подбору кредитных продуктов для клиентов, а именно
            предлагает клиенту список предложений кредитных учреждений, некредитных финансовых организаций,
            в которые клиент может обратиться с целью оформления заявки на кредитный продукт. Не является
            банком или кредитором, не относится к финансовым учреждениям и не несёт ответственности за последствия
            любых заключенных договоров кредитования или условия по заключенным договорам.<br><br>
            Совершая любые действия на сайте, вы даете свое
            <a href="#" @click="goToDoc('processing-personal-data')">Согласие на обработку персональных данных</a>.<br><br>
            Оставляя свои контактные данные на сайте, пользователь дает свое
            <a href="#" @click="goToDoc('promotional-materials')">согласие на получение информации о компании и партнерах компании</a>.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Footer',
  methods: {
    goHome() {
      this.$router.push('/');
    },
    goToDoc(documentType) {
      this.$router.push('/documents/' + documentType);
    },
  }
};
</script>

<style>
.footer a {
  color: var(--white-72);
}
</style>
